import { render, staticRenderFns } from "./AuctionsHistoryPage.vue?vue&type=template&id=5671fd54"
import script from "./AuctionsHistoryPage.vue?vue&type=script&lang=js"
export * from "./AuctionsHistoryPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports